<template>
    <div>
        <div class="container">
            <section class="small-container">
                <h3 class="iconfont iconxiala">合同信息</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon inline :model="contract" ref="contract" label-width="200px" :disabled="readonly" :rules="rules">
                    <el-row>
                        <el-col :span="12">
                            <!-- @focus="showContractDialog" -->
                            <el-form-item label="合同名称：" prop="contactName" class="noMarginBottom">
                                <el-input v-model.trim="contract.contactName"
                                        
                                        size="mini"
                                        class="minWidth"
                                        readonly
                                        placeholder="请选择合同">
                                    <!-- <i slot="suffix" class="iconfont iconjiansuo"  @click="showContractDialog" ></i> -->
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="合同编码：" prop="contactCode" class="noMarginBottom">
                                <el-input v-model.trim="contract.contactCode"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="合同总额(含税)：" prop="signContactAmount" class="noMarginBottom">
                                <el-input v-model.trim="contract.signContactAmount"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="合同状态：" prop="contractStatus" class="noMarginBottom">
                                <el-input v-model.trim="contract.contractStatus"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="计价方式：" prop="valuationType" class="noMarginBottom">
                                <el-input v-model.trim="contract.valuationType"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="合同签订时间：" prop="signTime" class="noMarginBottom">
                                <el-input v-model.trim="contract.signTime"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="合同开始日期：" prop="startTime" class="noMarginBottom">
                                <el-input v-model.trim="contract.startTime"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="合同类型：" prop="invoiceType" class="noMarginBottom">
                                <el-input v-model.trim="contract.invoiceType"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="签订金额：" prop="signContactAmount" class="noMarginBottom">
                                <el-input v-model.trim="contract.signContactAmount"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="合同结束日期：" prop="endTime" class="noMarginBottom">
                                <el-input v-model.trim="contract.endTime"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="应付未付金额：" prop="remainAmount" class="noMarginBottom">
                                <el-input v-model.trim="contract.remainAmount"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="已付金额：" prop="paidAmount" class="noMarginBottom">
                                <el-input v-model.trim="contract.paidAmount"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="项目：" class="noMarginBottom">
                                <el-select clearable filterable size="mini" placeholder="项目"
                                disabled
                                           class="minWidth" @change="changeRegionalCompany"
                                           v-model="contract.companyName">
                                    <el-option
                                        v-for="item in treeData"
                                        :key="item.id"
                                        :label="item.companyName"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="供应商名称：" prop="supplierName" class="noMarginBottom">
                                <el-input v-model.trim="contract.supplierName"
                                        size="mini"
                                        readonly
                                        class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
        </div>

        <contractDialog ref="contractDialog" @callback="callbackSelectContact"></contractDialog>
    </div>
</template>

<script>
import Vue from 'vue'
export default Vue.component('contract',{
    name: "contract",
    props: ['readonly'],
    data(){
        return{
            contract:{},
            rules:{
                companyName:[{
                    required: true,
                    message: '请输入项目名称',
                    trigger: 'change'}],
                    companyName:[{
                    required: true,
                    message: '请输入项目名称',
                    trigger: 'change'}]
            },
            area:[],
            treeData:[],
        }
    },
    mounted() {
        this.getCompanyList();
        this.getTree();
    },
    methods:{
        setData(data){
            if(data){
                this.contract = data
                // console.log('合同',this.contract)
                if (data.projectName){
                    this.contract.companyName = data.projectName
                } else {
                    this.contract.companyName = data.companyName
                }
            }
        },
        getTree(){
            let that = this;
            this.$root.getFunc("v1/sCompany/getCompanyTree",function (res) {
                that.treeData = res.data.data
            })
        },
        getCategoryInfo(fn){
            if(!this.contract.categoryId){
                return
            }
            let that = this;
            that.$root.getHttp('/v1/sSuppliersCategory/getCategoryInfo/'+this.contract.categoryId, function (res) {
                that.$set(that.contract, 'parentCategoryId', res.data.data.parentCategoryId);
                that.$set(that.contract, 'parentCategoryCode', res.data.data.parentCategoryCode);
                that.$set(that.contract, 'grandParentCategoryId', res.data.data.grandParentCategoryId);
                that.$set(that.contract, 'grandParentCategoryCode', res.data.data.grandParentCategoryCode);
                that.$set(that.contract, 'categoryId', res.data.data.id);
                fn && fn();
            })
        },
        callbackSelectContact(val){
            this.contract = val;
            this.getCategoryInfo(()=>{
                this.$emit('callback');
            });
        },
        showContractDialog(){
            this.$refs['contractDialog'].show();
        },
        getCompanyList(){
            let that = this;
            that.$root.postHttp('/v1/sRegionalCompany/public/getRegionalCompanyList',{
                "pageFlag": 0,
                "pageNumber": 0,
                "pageSize": 0,
                "regionalCompanyCode": "",
                "regionalCompanyName": ""
            },function (res) {
                that.area = res.data.data.list
            });
        },
        changeRegionalCompany(val){
            this.$emit('changeRegional', val);
        },
        submitFormPromise(formName){
          return this.submitFormFnc(formName)();
        },
        submitFormFnc(formName){
            let that = this;
            var f = function (){
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if(Array.isArray(that.$refs[formName])){
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if(valid){
                            resolve(true);
                        } else {
                            reject('请完成必填信息的填写！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
    }
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类

@import '../../../assets/_var.scss';
@import "../../../assets/iconfont/iconfont.css";

.container /deep/{
    margin-top: -14px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .el-message-box {
        width: 500px;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .f14 {
        font-size: 14px!important;
    }

    & .unit {
        width: 100px;
        margin-right: 5px;
    }

    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }

        & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;
        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }
    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }
    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }
    .dele:hover img {
        transform: scale(1.1);
    }
    & .remarks {
        width: 95%;
    }

    & .naturalForm  {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    & h4{
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;

    }
    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }

    .attachmentForm {
        .el-form-item__content {
            // width: 250px;
        }
    }

    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4 !important;
        border-radius: 0px;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }

    .maxWidthForm {
        width: 100%;
        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .onlySupplier {
        .file-list .file-name {
            max-width: 190px!important;
        }
    }

    .el-form-item {
        width: 100%;
    }
    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 33px;
    }
}
.box-card{
    margin-bottom: 15px;
}
.minWidth{
    width: 250px;
}
h3{
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
    padding-left: 25px;
}

.iconxiala::before {
    position: absolute;
    left: 0px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}
.noMarginBottom{
    // margin-bottom: 0!important;
    margin-bottom: 10px!important;
    .tipWrap {
        position: relative;
        min-width: 250px;
        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            // background: url('../../../assets/img/detail/tip.png') no-repeat left center;
        }
    }
}

.cf:before,.cf:after {
    content:"";
    display:table;
}
.cf:after { clear:both; }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/contract.vue